// @flow
import * as React from 'react';
import RichTextInput from 'components/RichTextInput';
import ClientOnly from 'containers/ClientOnly';
import Field from './Field';

const RichTextField = ({
  name,
  label,
  description,
  matchGeneralError,
  simple,
  limited,
  h2,
  h1,
  onKeyUp,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  matchGeneralError?: string,
  simple?: boolean,
  h1?: boolean,
  h2?: boolean,
  limited?: boolean,
  onUpdateValue?: string => void,
  onKeyUp?: string => void
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    matchGeneralError={matchGeneralError}
    renderInput={({ value, id, qaId, hasError, updateValue, labelRef }) => (
      <ClientOnly>
        <RichTextInput
          labelRef={labelRef}
          id={id}
          name={name}
          value={value}
          hasError={hasError}
          data-qa-id={qaId}
          onChange={richText => {
            updateValue(richText);
            if (props.onUpdateValue) {
              props.onUpdateValue(richText);
            }
          }}
          onKeyUp={onKeyUp}
          simple={simple}
          limited={limited}
          h1={h1}
          h2={h2}
          {...props}
        />
      </ClientOnly>
    )}
  />
);

export default RichTextField;
